<template>
  <v-app id="app">
    <head-bar></head-bar>
    <main>
      <router-view></router-view>
    </main>
    <foot></foot>
    <cookie-bar v-if="!cookiesAccepted" @cookies-accepted="setCookiesAccepted"></cookie-bar>
  </v-app>
</template>

<script>
import HeadBar from "./core/components/header/Header.vue";
import Foot from "./core/components/footer/Footer.vue";
import Tour from "./tour/Tour.vue";
import CookieBar from "./core/components/cookie/CookieBar.vue";

export default {
  name: "App",
  data: () => ({
    cookiesAccepted: localStorage.getItem("auszeit-cookies-accepted")
  }),
  components: {
    HeadBar,
    Foot,
    CookieBar
  },
  mounted() {
    this.$nextTick(() => {
      this.$router.addRoutes(
        this.getTourList().map(tour => ({
          path: `/${tour.id}`,
          component: Tour
        }))
      );
    });
  },
  methods: {
    setCookiesAccepted() {
      localStorage.setItem("auszeit-cookies-accepted", true);
      this.cookiesAccepted = true;
    }
  }
};
</script>

<style lang="scss">
/*@font-face {
  font-family: "SoleilBo";
  src: url("./assets/fonts/3A7B72_0_0.eot");
  src: url("./assets/fonts/3A7B72_0_0.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/3A7B72_0_0.woff2") format("woff2"),
    url("./assets/fonts/3A7B72_0_0.woff") format("woff"),
    url("./assets/fonts/3A7B72_0_0.ttf") format("truetype");
}*/
@font-face {
  font-family: "SoleilSb";
  src: url("./assets/fonts/3A7C74_0_0.eot");
  src: url("./assets/fonts/3A7C74_0_0.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/3A7C74_0_0.woff2") format("woff2"),
    url("./assets/fonts/3A7C74_0_0.woff") format("woff"),
    url("./assets/fonts/3A7C74_0_0.ttf") format("truetype");
}
@font-face {
  font-family: "SoleilLt";
  src: url("./assets/fonts/3A7B72_1_0.eot");
  src: url("./assets/fonts/3A7B72_1_0.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/3A7B72_1_0.woff2") format("woff2"),
    url("./assets/fonts/3A7B72_1_0.woff") format("woff"),
    url("./assets/fonts/3A7B72_1_0.ttf") format("truetype");
}
@font-face {
  font-family: "Soleil";
  src: url("./assets/fonts/3A7B72_2_0.eot");
  src: url("./assets/fonts/3A7B72_2_0.eot?#iefix") format("embedded-opentype"),
    url("./assets/fonts/3A7B72_2_0.woff2") format("woff2"),
    url("./assets/fonts/3A7B72_2_0.woff") format("woff"),
    url("./assets/fonts/3A7B72_2_0.ttf") format("truetype");
}

@font-face {
  font-family: "feather";
  src: url("./assets/fonts/feather.eot?t=1501834582692");
  src: url("./assets/fonts/feather.eot?t=1501834582692#iefix")
      format("embedded-opentype"),
    url("./assets/fonts/feather.woff?t=1501834582692") format("woff"),
    url("./assets/fonts/feather.ttf?t=1501834582692") format("truetype"),
    url("./assets/fonts/feather.svg?t=1501834582692#feather") format("svg");
}

html {
  width: 100vw;
  min-height: 100vh;
  overflow-y: auto !important;
}

body {
  margin: 0;
  background-color: #ffffff;
  max-width: 100vw;
  &.no-scroll {
    overflow: hidden !important;
  }
}

.theme--light.v-application {
  background-color: #ffffff !important;
}

#app {
  font-family: Soleil, sans-serif;

  //font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
